module.exports = __webpack_public_path__ + "img/icon_test_step.132a8b36.png";